/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：717
 */

"use strict"

var r = require(/* 168 */"../1648/168")
module.exports = function (e, t) {
  var n = [][e]
  return !!n && r(function () {
    n.call(null, t || function () {
      throw 1
    }, 1)
  })
}
